<script lang="ts">
  import Icon from './Icon.svelte';
  /**
   * Плаваюча панель масових дій для Kanban-дошки. З'являється знизу по центру
   * коли вибрано ≥1 картку. Дії делегуються callback'ами — реальну логіку
   * (bulk edit / delete / export) виконує батьківський route, повторно
   * використовуючи наявні модалки (BulkEditModal, confirm-delete, CSV-export).
   */
  let {
    count,
    onEdit,
    onDelete,
    onExport,
    onClear,
    busy = false,
  }: {
    count: number;
    /** Масове редагування (BulkEditModal). Undefined → кнопка прихована. */
    onEdit?: () => void;
    onDelete?: () => void;
    onExport?: () => void;
    onClear: () => void;
    busy?: boolean;
  } = $props();
</script>

{#if count > 0}
  <div class="fixed bottom-5 left-1/2 -translate-x-1/2 z-40 flex items-center gap-1 rounded-2xl border border-[var(--color-border-3)] bg-white px-2 py-1.5 shadow-2xl">
    <span class="px-2.5 py-1 text-[12px] font-bold text-[var(--color-pu-3)]">
      Вибрано: {count}
    </span>
    <span class="h-5 w-px bg-[var(--color-border-3)]"></span>

    {#if onEdit}
      <button
        type="button"
        onclick={onEdit}
        disabled={busy}
        class="inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-[12px] font-semibold hover:bg-[var(--color-bg-3)] disabled:opacity-50"
      ><Icon name="edit" size={14} /> Редагувати</button>
    {/if}
    {#if onExport}
      <button
        type="button"
        onclick={onExport}
        disabled={busy}
        class="inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-[12px] font-semibold hover:bg-[var(--color-bg-3)] disabled:opacity-50"
      ><Icon name="export" size={14} /> Експорт</button>
    {/if}
    {#if onDelete}
      <button
        type="button"
        onclick={onDelete}
        disabled={busy}
        class="inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-[12px] font-semibold text-rose-600 hover:bg-rose-50 disabled:opacity-50"
      ><Icon name="delete" size={14} /> Видалити</button>
    {/if}

    <span class="h-5 w-px bg-[var(--color-border-3)]"></span>
    <button
      type="button"
      onclick={onClear}
      disabled={busy}
      class="inline-flex items-center justify-center rounded-lg px-2.5 py-1.5 text-[12px] text-[var(--color-text-muted)] hover:bg-[var(--color-bg-3)] disabled:opacity-50"
      title="Зняти вибір"
      aria-label="Зняти вибір"
    ><Icon name="close" size={14} /></button>
  </div>
{/if}
